'use strict'

class CertificateService {
  constructor ($http, API) {
    this.$http = $http
    this.API = API + '/api/certificate'
  }

  searchSPCRFPF (cpf, dateBirthday) {
    return this.$http({
      method: 'POST',
      url: this.API + '/spcrfpf',
      data: {
        cpf,
        dateBirthday
      }
    })
  }

  searchSPCRFPJ (cnpj, cpf, dateBirthday) {
    return this.$http({
      method: 'POST',
      url: this.API + '/spcrfpj',
      data: {
        cpf,
        dateBirthday,
        cnpj
      }
    })
  }

  registerPresentialPurchase (certificate) {
    return this.$http({
      method: 'POST',
      url: this.API + '/presential-purchase',
      data: certificate
    })
  }

  registerOnlinePurchase (certificate) {
    return this.$http({
      method: 'POST',
      url: this.API + '/online-purchase',
      data: certificate
    })
  }

  sendEmailPresentialPurchase (certificate) {
    return this.$http({
      method: 'POST',
      url: this.API + '/complet',
      data: certificate
    })
  }

  sendEmailOnlinePurchase (certificate) {
    return this.$http({
      method: 'POST',
      url: this.API + '/send-email/online-purchase',
      data: certificate
    })
  }

  searchBiometry (cpf) {
    return this.$http({
      method: 'GET',
      url: this.API + '/biometry/' + cpf
    })
  }
}

angular.module('app').service('certificateService', CertificateService)



//////////////////
// WEBPACK FOOTER
// ./services/certificate.service.js
// module id = 100
// module chunks = 0